import React from 'react';
import { ActionMenuState, FileData } from '../../types/training';
import './ActionMenu.css';

interface ActionMenuProps {
  menuState: ActionMenuState;
  onClose: () => void;
  onAction: (action: string, file: FileData, boxId: string) => void;
}

const ActionMenu: React.FC<ActionMenuProps> = ({ menuState, onClose, onAction }) => {
  if (!menuState.visible || !menuState.file || !menuState.boxId) return null;

  const handleActionClick = (action: string) => {
    if (menuState.file && menuState.boxId) {
      onAction(action, menuState.file, menuState.boxId);
    }
    onClose();
  };

  const actions = ['Open File', 'Edit Marks/Annotations', 'View Details', 'Remove', 'Copy to Example Input', 'Copy to Example Output'];

  return (
    <div
      className="action-menu"
      style={{ 
        top: `${menuState.y - 20}px`, 
        left: `${menuState.x - 260}px`
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <ul className="action-menu-list">
        {actions.map((action) => (
          <li
            key={action}
            className="action-menu-item"
            onClick={() => handleActionClick(action)}
          >
            {action}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ActionMenu;

